import type { WithActiveBranchId } from '@app/api/shared';

export enum LegalEntitiesEndpoints {
  UpdateLegalEntity = 'UpdateLegalEntity',
  GetLegalEntities = 'GetLegalEntities',
  GetLegalEntitiesForSystem = 'GetLegalEntitiesForSystem',
  GetLegalEntityById = 'GetLegalEntityById',
}

export interface ModelLegalEntity {
  Id: number;
  Name: string | null;
  Description: string | null;
  Kpp: number | null;
  TaxPayerId: number | null;
  IsDeleted: boolean;
  CountConstantsPayments: number;
}

export interface ModelItemEx {
  Id: number;
  Name: string | null;
  IsDeleted: boolean;
}

export type UpdateLegalEntityRequest = WithActiveBranchId<{
  data: ModelLegalEntity;
}>;

export type GetLegalEntitiesRequest = WithActiveBranchId<{
  includeDeleted: boolean;
}>;

export type GetLegalEntitiesForSystemRequest = WithActiveBranchId<{
  includeDeleted: boolean;
}>;

export type GetLegalEntityByIdRequest = WithActiveBranchId<{
  legalEntityId: number;
}>;

export type UpdateLegalEntityResponse = ModelLegalEntity;
export type GetLegalEntitiesResponse = ModelLegalEntity[];
export type GetLegalEntitiesForSystemResponse = ModelItemEx[];
export type GetLegalEntityByIdResponse = ModelLegalEntity;
